import { merge } from 'lodash';
import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
import { ApexChartsOption } from 'src/components/Charts/Apexcharts';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardHeader, Box } from '@material-ui/core';

// ----------------------------------------------------------------------

const useStyles = makeStyles(() => ({
  root: {}
}));

// ----------------------------------------------------------------------

GraficaDesp.propTypes = {
  className: PropTypes.string,
  DespCasa: PropTypes.shape({
    pagocasad: PropTypes.array.isRequired,
    valorcasad: PropTypes.array.isRequired
  }).isRequired
};

function GraficaDesp({ className, DespCasa, ...other }) {
  const classes = useStyles();
  var mesn = 1;
  const pagoCasa = DespCasa.pagocasad;
  const valorCasa = DespCasa.valorcasad;
  let mes = [];

  pagoCasa.map(() => {
    mes.push(mesn);
    mesn++;
    return 0;
  });

  const chartData = [
    {
      name: 'Pagos de la casa',
      type: 'area',
      data: pagoCasa
    },
    {
      name: 'Depreciacion de la casa',
      type: 'area',
      data: valorCasa
    }
  ];
  const chartOptions = merge(ApexChartsOption(), {
    stroke: { width: [0, 2, 3] },
    plotOptions: { bar: { columnWidth: '12%', endingShape: 'rounded' } },
    fill: { type: ['solid', 'gradient', 'solid'] },
    labels: mes,
    xaxis: { type: 'text' },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: function (y) {
          if (typeof y !== 'undefined') {
            return y.toFixed(2) + '$';
          }
          return y;
        }
      }
    }
  });

  return (
    <Card className={clsx(classes.root, className)} {...other}>
      <CardHeader title="depreciacion del Activo y pago del Activo" subheader="del credito seleccionado" />
      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        <ReactApexChart type="line" series={chartData} options={chartOptions} height={364} />
      </Box>
    </Card>
  );
}

export default GraficaDesp;
